<template>
  <div>
    <header>
      <core-app-bar />
    </header>
    <main role="main">
      <core-view />
    </main>
    <footer class="main-footer">
      <core-footer />
    </footer>
  </div>
</template>

<script>
export default {
  middleware: 'auth',
  components: {
    CoreAppBar: () => import('@/components/core/guest/AppBar'),
    CoreView: () => import('@/components/core/guest/View'),
    CoreFooter: () => import('@/components/core/guest/Footer'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  head: {
    bodyAttrs: {
      class: 'hold-transition layout-top-nav',
    },
  },
}
</script>
